module.exports = __webpack_public_path__ + "static/mingyu.chi-2767b25cb373cb159100e148e757c632.jpeg";